import type { Cart } from "@packages/sdk";

type CostPerMonthProps = Pick<Cart, "renewal_total" | "product">;

export const costPerMonth = ({
  product: { billing_period },
  renewal_total,
}: CostPerMonthProps) => {
  switch (billing_period.unit) {
    case "day":
      return renewal_total * (30 / billing_period.number);
    case "week":
      return renewal_total * (30 / (billing_period.number / 7));
    case "month":
      return renewal_total;
    case "year":
      return renewal_total / (12 * billing_period.number);
    default:
      return null;
  }
};
